import { useState } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Shared loading/error state + async submit wrapper used by all login forms.
 * Eliminates the duplicated try/catch/finally error-handling pattern.
 */
export function useFormSubmit() {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const runSubmit = async (fn: () => Promise<void>) => {
    setError(null);
    setLoading(true);
    try {
      await fn();
    } catch (err: any) {
      setError(err?.message ?? t('login.error.generic'));
    } finally {
      setLoading(false);
    }
  };

  return { loading, error, setError, runSubmit };
}
